const TOKENS = Object.freeze({
  EURC: 'EURC',
  USDC: 'USDC',
});

export default Object.freeze({
  TOKENS,
});
